document.addEventListener("DOMContentLoaded", function () {
    const accessToken = "IGAAVvm4lLDZBtBZAGFjRjJvRGh6UjRycTBWdWo2WVdWdTh3VWtnbjFQT1BCLVpLaFRlSTNwQXZAGcVZAERjUyTUNIb2VuM0txUDVZASjdCcjQycFBQYzMwc0lMN0Q4TUFMT1JpeTBHUWVmS3Bhak0zZA1VsYXgyS0NEV0Y2azZAXTHVhdwZDZD";
    const container = document.querySelector(".instagram-carousel .slides");
    const prevButton = document.querySelector(".instagram-carousel .prev");
    const nextButton = document.querySelector(".instagram-carousel .next");
    const postLimit = 16;

    fetch(`https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url,permalink,caption&limit=${postLimit}&access_token=${accessToken}`)
        .then(response => response.json())
        .then(data => {
            let html = "";
            data.data.forEach((post) => {
                if (post.media_type === "IMAGE" || post.media_type === "CAROUSEL_ALBUM") {
                    html += `
                        <div class="slide">
                            <a href="${post.permalink}" target="_blank">
                                <img src="${post.media_url}" alt="${post.caption || 'Instagram Post'}" />
                            </a>
                        </div>
                    `;
                } else if (post.media_type === "VIDEO") {
                    html += `
                        <div class="slide">
                            <a href="${post.permalink}" target="_blank">
                                <video src="${post.media_url}" poster="${post.thumbnail_url}" muted loop playsinline></video>
                            </a>
                        </div>
                    `;
                }
            });
            container.innerHTML = html;

            initializeCarousel();
        })
        .catch((error) => console.error("Error fetching Instagram feed:", error));
});

function initializeCarousel() {
    const slidesContainer = document.querySelector(".instagram-carousel .slides");
    const prevButton = document.querySelector(".instagram-carousel .prev");
    const nextButton = document.querySelector(".instagram-carousel .next");
    const isMobile = window.innerWidth <= 768;
    let index = 0;

    if (!isMobile) {
        prevButton.addEventListener("click", () => {
            if (index > 0) {
                index--;
            } else {
                index = Math.floor(slidesContainer.children.length / 4) - 1; // Loop back to last set
            }
            updateCarousel();
        });

        nextButton.addEventListener("click", () => {
            if (index < Math.floor(slidesContainer.children.length / 4) - 1) {
                index++;
            } else {
                index = 0; // Loop back to start
            }
            updateCarousel();
        });

        function updateCarousel() {
            const offset = -index * 100;
            slidesContainer.style.transform = `translateX(${offset}%)`;
        }

        updateCarousel();
    }
}
